import * as React from 'react';
import { render } from 'react-dom';
import App from './Components/App';
// import registerServiceWorker from './registerServiceWorker';
import Provider from './State/Provider';

render((
    <Provider>
        <App />
    </Provider>
), document.getElementById('mlr-water-calculator'));

// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.tsx